(function ($, window) {
	'use strict';

	$(function () {
		const interval = 250;
		const visibleHeight = 300;
		const activeClass = 'sticky-header-active';
		const $body = $('body');
		const $staticHeader = $('.js-header');
		const $stickyHeader = $('.js-sticky-header');
		const $staticHeaderSearchBody = $('.js-search-body', $staticHeader);
		const $staticHeaderSearchTrigger = $('.js-search-close', $staticHeader);
		const $stickyHeaderSearchBody = $('.js-search-body', $stickyHeader);
		const $stickyHeaderSearchTrigger = $('.js-search-close', $stickyHeader);

		let didScroll = false;

		$(window).on('scroll', function () {
			didScroll = true;
		});

		setInterval(function () {
			if (didScroll) {
				handleScroll();
				didScroll = false;
			}
		}, interval);

		const handleScroll = () => {
			const currentScrollTop = ($(window).scrollTop() || $('body').scrollTop());

			if (currentScrollTop > visibleHeight) {
				if (!$body.hasClass(activeClass)) {
					$body.addClass(activeClass);

					if ($staticHeaderSearchBody.hasClass('site-search--is-active')) {
						$staticHeaderSearchTrigger.trigger('click');
					}
				}
			} else {
				if ($body.hasClass(activeClass)) {
					$body.removeClass(activeClass);

					if ($stickyHeaderSearchBody.hasClass('site-search--is-active')) {
						$stickyHeaderSearchTrigger.trigger('click');
					}
				}
			}
		};

		$(window).trigger('scroll');

		$('*', $stickyHeader).each(function (index, child) {
			$(child).attr('tabindex', '-1');
		});
	});
})(jQuery, window);
